import type { Locale } from '@appwin/shared';
import { Button, Page } from '@appwin/ui';
import { CLIENT_DOWNLOAD_URL, localePath } from '../config.js';
import { translator } from '../i18n.js';
import type { HeadInput } from '../head.js';

export function NotFoundPage({ locale }: { locale: Locale }) {
  const t = translator(locale);
  return (
    <Page>
      <main className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
        <h1 className="text-3xl font-semibold">{t('web.notFoundTitle')}</h1>
        <p className="text-muted">{t('web.notFoundHint')}</p>
        <div className="mt-4">
          <a href={localePath(locale, '/')}>
            <Button>{t('nav.catalog')}</Button>
          </a>
        </div>
      </main>
    </Page>
  );
}

export function buildNotFoundHead(locale: Locale): HeadInput {
  const t = translator(locale);
  return {
    title: `${t('web.notFoundTitle')} — ${t('common.appName')}`,
    description: t('web.notFoundHint'),
    canonicalPath: localePath(locale, '/404'),
    locale,
    noindex: true,
  };
}

export function DownloadPage({ locale }: { locale: Locale }) {
  const t = translator(locale);
  return (
    <Page>
      <main className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
        <h1 className="text-3xl font-semibold">{t('web.downloadClient')}</h1>
        <p className="text-muted">{t('web.downloadClientHint')}</p>
        <a href={CLIENT_DOWNLOAD_URL} download className="mt-2">
          <Button>{t('web.downloadClient')}</Button>
        </a>
      </main>
    </Page>
  );
}

export function buildDownloadHead(locale: Locale): HeadInput {
  const t = translator(locale);
  return {
    title: `${t('web.downloadClient')} — ${t('common.appName')}`,
    description: t('web.downloadClientHint'),
    canonicalPath: localePath(locale, '/download'),
    locale,
  };
}

export function buildCatalogHead(locale: Locale): HeadInput {
  const t = translator(locale);
  return {
    title: `${t('catalog.title')} — ${t('common.appName')}`,
    description: t('web.description'),
    canonicalPath: localePath(locale, '/'),
    locale,
  };
}
